export default "__VITE_ASSET__CXcdLLvB__"